export * from './ch-badge.module';
export * from './ch-badge.component';